import { MAX_SIZE, QUALITY } from './constants'

/*
    Convert Image file to fit a max size (to limit data sent to storage)
    variable on size and quality (0.8 is a good ratio as it render correctly the initial file and save 80% space)
*/
export const convertImage = (b64: string, type: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    const img = document.createElement('img')
    img.src = b64

    img.onload = () => {
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')

      if (ctx) {
        ctx.drawImage(img, 0, 0)

        const ratio = img.width / img.height

        const maxImageSize = img.width > img.height ? 'width' : 'height'
        const maxSize = maxImageSize === 'width' ? img.width : img.height

        const overSized = maxSize > MAX_SIZE

        const updatedMax = overSized ? MAX_SIZE : maxSize
        const updatedMin = maxImageSize === 'width' ? updatedMax / ratio : updatedMax * ratio

        const updatedWidth = maxImageSize === 'width' ? updatedMax : updatedMin
        const updatedHeight = maxImageSize === 'height' ? updatedMax : updatedMin

        canvas.width = updatedWidth
        canvas.height = updatedHeight

        const ctx2 = canvas.getContext('2d')

        if (ctx2) {
          ctx2.drawImage(img, 0, 0, updatedWidth, updatedHeight)
          resolve(canvas.toDataURL(type, QUALITY))
        }
      } else {
        reject('cannot read file')
      }
    }
  })
}

export const convertJPGType = (type?: string | null) => type && type.replace('jpg', 'jpeg')
